import { render, staticRenderFns } from "./Clients2.vue?vue&type=template&id=256e020a&scoped=true"
import script from "./Clients2.vue?vue&type=script&lang=js"
export * from "./Clients2.vue?vue&type=script&lang=js"
import style0 from "./Clients2.vue?vue&type=style&index=0&id=256e020a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e020a",
  null
  
)

export default component.exports